// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","footerContainer":"Footer_footerContainer__cqEAW"};